import { render, staticRenderFns } from "./TableAssistant.vue?vue&type=template&id=389df49e&scoped=true"
import script from "./TableAssistant.vue?vue&type=script&lang=js"
export * from "./TableAssistant.vue?vue&type=script&lang=js"
import style0 from "./TableAssistant.vue?vue&type=style&index=0&id=389df49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389df49e",
  null
  
)

export default component.exports